import { PushNotification } from 'src/core/models'
import axios from 'axios'

const apiAxios = axios.create({ baseURL: process.env.PUSH_NOTIFICATIONS_URL })

export async function getAllNotificationsAPI(): Promise<PushNotification[]> {
  const { data, status } = await apiAxios.get('/api/v1/notification/getAllNotifications')

  if (status !== 200) {
    throw new Error('Failed to fetch all notifications')
  }

  return data
}

export async function createPushNotificationsAPI(notification: PushNotification): Promise<any> {
  const { status } = await apiAxios.post('/api/v1/notification/createNotification', notification, {
    headers: { 'Content-Type': 'application/json' },
  })

  if (status !== 201) {
    throw new Error('Failed to create notification')
  }

  return status
}

export async function updateNotificationAPI(requestData: PushNotification): Promise<any> {
  const { id, ...data } = requestData

  const { status } = await apiAxios.patch(`/api/v1/notification/updateNotification/${id}`, data, {
    headers: { 'Content-Type': 'application/json' },
  })

  if (status !== 202) {
    throw new Error('Failed to update notification')
  }

  return status
}

export async function deleteNotificationAPI(id: number): Promise<any> {
  const { status } = await apiAxios.delete(`/api/v1/notification/deleteNotification/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  })

  if (status !== 200) {
    throw new Error('Failed to delete notification')
  }

  return status
}
